import { Carrot } from "@/components/Carrot";

export function Footer() {
  return (
    <footer className="bg-field-deep text-cream">
      <div className="mx-auto flex max-w-7xl flex-col gap-6 px-5 py-8 sm:flex-row sm:items-center sm:justify-between sm:px-8">
        <a href="/" aria-label="CarrotOnTheHorse home" className="flex items-center gap-3 rounded-sm focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-carrot">
          <Carrot aria-hidden className="h-7 w-7" />
          <div>
            <p className="font-display text-sm font-bold">CarrotOnTheHorse</p>
            <p className="mt-0.5 text-xs text-cream/65">Carrot On The Horse, Inc. © 2026</p>
          </div>
        </a>
        <nav aria-label="Footer" className="flex items-center gap-6 text-xs font-semibold text-cream/60">
          <a href="/about" className="footer-link">About</a>
          <a href="/team" className="footer-link">Team</a>
          <a href="/privacy" className="footer-link">Privacy</a>
        </nav>
      </div>
    </footer>
  );
}
